import { useEffect } from 'react';
import { ThemeProvider, createTheme, useTheme } from '@mui/material/styles';

export default function ThemeUpdater({ children, primaryColor, fontFamily, fontUrl, titleFontFamily, titleFontUrl }) {
    const outerTheme = useTheme();

    const loadFont = !!fontFamily && !!fontUrl;
    const loadTitleFont = !!titleFontFamily && !!titleFontUrl;
    
    const theme = createTheme({
        ...outerTheme,
        ...(loadFont && {
            typography: {
                fontFamily: fontFamily,
                ...(loadTitleFont && {
                    h1: {
                        fontFamily: titleFontFamily,
                    },
                    h2: {
                        fontFamily: titleFontFamily,
                    },
                    h3: {
                        fontFamily: titleFontFamily,
                    },
                    h4: {
                        fontFamily: titleFontFamily,
                    },
                    h5: {
                        fontFamily: titleFontFamily,
                    },
                    h6: {
                        fontFamily: titleFontFamily,
                    },
                })
            }
        }),
        palette: {
            ...outerTheme.palette,
            primary: outerTheme.palette.augmentColor({
                color: {
                    main: primaryColor || outerTheme.palette.primary.main,
                },
                name: 'primary',
            }),
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        fontWeight: 'bold',
                    }
                }
            }
        }
    });

    return (
        <ThemeProvider theme={theme}>
            {loadFont && <style>
                {`
                    @font-face {
                        font-family: ${fontFamily};
                        src: url('${fontUrl}');
                        font-weight: normal;
                        font-style: normal;
                    }
                    @font-face {
                        font-family: ${fontFamily};
                        src: url('${fontUrl}');
                        font-weight: bold;
                        font-style: normal;
                    }
                `}
            </style>}
            {loadTitleFont && <style>
                {`
                    @font-face {
                        font-family: ${titleFontFamily};
                        src: url('${titleFontUrl}');
                        font-weight: normal;
                        font-style: normal;
                    }
                    @font-face {
                        font-family: ${titleFontFamily};
                        src: url('${titleFontUrl}');
                        font-weight: bold;
                        font-style: normal;
                    }
                `}
            </style>}
            {children}
        </ThemeProvider>
    );
} 